import {MAIN_API} from "@/api/apiUrl";
import axios from 'axios'

const authorizationApi = {
    fullUrl: MAIN_API + '/api/auth',
    login: function (data) {
        return new Promise((resolve, reject) => {
            axios({
                url: this.fullUrl + '/login',
                data,
                headers: {'Content-Type': 'application/json'},
                method: 'POST'
            }).then((response) => {
                resolve(response.data)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    authorize: function (response) {
        console.log('resp', response)
        localStorage.setItem('token', response.token);
        localStorage.setItem('role', response.role);
    },
    isAuthenticated: function () {
        return !!localStorage.getItem('token')
    }
}

export default authorizationApi
